/* Velora - fade-in on scroll.
   Progressive enhancement: the hidden state is applied by JS, so with
   JS off or reduced-motion on, content renders normally.
   ~0.6kb, no dependencies, one shared observer, unobserves after firing. */
(function () {
  'use strict';

  var SELECTOR = [
    '.velora-lp .bcard',
    '.velora-lp .rcard',
    '.velora-lp .step',
    '.velora-lp .tcell',
    '.velora-lp .col',
    '.velora-lp .stat',
    '.velora-lp .feat',
    '.velora-lp .fitem',
    '.velora-lp h2.sec',
    '.velora-lp .sec-lead'
  ].join(',');

  function init() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var els = document.querySelectorAll(SELECTOR);
    if (!els.length) return;

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        entries[i].target.classList.add('v-in');
        io.unobserve(entries[i].target);
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    for (var i = 0; i < els.length; i++) {
      // Already in view on load: skip the animation, avoid a flash.
      if (els[i].getBoundingClientRect().top < window.innerHeight * 0.9) continue;
      els[i].classList.add('v-rv');
      els[i].style.transitionDelay = (Math.min(i % 6, 5) * 45) + 'ms';
      io.observe(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
